/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";

// Images
import post1 from "assets/images/posts/RevBits-FMP.png";
import post2 from "assets/images/posts/cnbc-news.jpeg";
import post3 from "assets/images/posts/CHI-LATAM.jpg";
import post4 from "assets/images/posts/cyber-ia-news.jpeg";
import post5 from "assets/images/posts/LATAM-rise.jpeg";
import post6 from "assets/images/posts/laad.png";
import post7 from "assets/images/posts/curso-templar.jpeg";
import post8 from "assets/images/examples/blog2.jpg";
import { responsiveFontSizes } from "@mui/material";

function Places() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            Mais recentes artigos
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post1}
              title="Nova parceria com a RevBits"
              description="A parceria estratégica abre novos mercados para que a FMP Soluções e a RevBits ofereçam proteção superior a uma base 
              de clientes ampliada ..."
              action={{
                type: "external",
                route: "https://www.businesswire.com/news/home/20250708106243/pt",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post2}
              title="CNCiber"
              description="O Comitê Nacional de Cibersegurança definiu parâmetros para que a atuação internacional do Brasil em cibersegurança seja 
              coordenada entre órgãos públicos e entidades...."
              action={{
                type: "external",
                route: "https://rsdd.esd.gov.br/index.php/rsdd/article/view/54/24",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post3}
              title = "China’s Worrisome Cyber Attacks"
              description="Attacks from China state-sponsored hacker groups in Latin America have not only increased in recent years but have 
              also become more sophisticated ..."
              action={{
                type: "external",
                route: "https://dialogo-americas.com/articles/chinas-worrisome-cyber-penetration-in-latin-america/",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <BackgroundBlogCard
              image={post4}
              title="IA - Nova ameaça cibernética"
              description="Os agentes de IA estão prestes a transformar o cenário da cibersegurança — você está preparado para isso?"
              action={{
                type: "external",
                route: "https://mittechreview.com.br/ciberataques-agentes-ia-riscos-seguranca-digital/",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={3}>
            <BackgroundBlogCard
              image={post5}
              title="América latina - 40% acima da média mundial"
              description="Cyber threats are accelerating faster in Latin America than anywhere else in the world.The trend has been building 
              for at least a year now, actually. Last summer, ..."
              action={{
                type: "external",
                route: "https://www.darkreading.com/cybersecurity-analytics/latin-american-orgs-more-cyberattacks-global-average",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post6}
              title="FMP participa da LAAD"
              description="Nossos diretores prestigiaram nesta semana passada a LAAD, ocorrida no Rio de Janeiro e com a presença das forças armadas brasileiras e ..."
              action={{
                type: "external",
                route: "https://laadexpo.com.br/defence/en/#pll_switcher",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post7}
              title="FMP Soluções e Templar Executives ministram cursos para Forças brasileiras"
              description="Nas últimas duas semanas a FMP Soluções, empresa brasileira, e a Templar Executives ministraram cursos para ..."
              action={{
                type: "internal",
                route: "https://www.linkedin.com/feed/update/urn:li:activity:7308166805091483648",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post8}
              title="FMP Soluções e Templar Executives anunciam parceria"
              description="A FMP Soluções e a Templar Executives anunciam parceria para promulgar o conhecimento em segurança cibernética em toda América latina ..."
              action={{
                type: "internal",
                route: "/pages/blogs/author",
                color: "info",
                label: "Saiba mais",
              }}
            />
          </Grid>
          
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Places;
